import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';

import { AuthService } from '../auth/auth.service';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
	constructor(
		private injector: Injector,
		private log: NGXLogger) {
	}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			tap(
				(event: HttpEvent<any>) => {
				},
				(err: any) => {
					if (err instanceof HttpErrorResponse) {
						if(!this.log){
							this.log = this.injector.get(NGXLogger);
						}
						if (err.status === 401) {
							this.log.debug('AuthExpiredInterceptor', err);
							const loginService: AuthService = this.injector.get(AuthService);
							const router: Router = this.injector.get(Router);
							loginService.logout();
							router.navigate(['population']);
						}
					}
				}
			)
		);
	}
}
